import { useDisclosure } from '@cardboard-ui/react';
import React from 'react';
import { OptionsMenuItem } from 'components/OptionsMenu/OptionsMenuItem';
import { t } from '@lingui/macro';
import { BullhornIcon } from 'components/icons';
import { graphql, useFragment } from 'utils/graphClient';
import { CreateAnnouncementOverlay } from 'apps/TenantApp/screens/Space/screens/Activity/components/Announcements/components/CreateAnnouncementOverlay';
import { AnnounceOption_node$key } from './__generated__/AnnounceOption_node.graphql';

const announceOptionFragment = graphql`
  fragment AnnounceOption_node on Node {
    __typename
    id
    ... on Folder {
      space {
        __typename
        id
        modules {
          ... on SpaceAnnouncementsModule {
            canCreateAnnouncement {
              value
            }
          }
        }
      }
    }
  }
`;

interface AnnounceOptionProps {
  node: AnnounceOption_node$key;
}

export const AnnounceOption = ({ node: _node }: AnnounceOptionProps) => {
  const { id, space } = useFragment(announceOptionFragment, _node);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const canCreateAnnouncement = space?.modules.find(
    (m) => !!m.canCreateAnnouncement?.value,
  );

  if (!space || !canCreateAnnouncement) return null;

  return (
    <>
      <OptionsMenuItem
        icon={<BullhornIcon />}
        onClick={onOpen}
      >{t`Create announcement`}</OptionsMenuItem>
      <CreateAnnouncementOverlay
        spaceId={space.id}
        addToConnectionIds={[]}
        linkIds={[id]}
        isOpen={isOpen}
        onClose={onClose}
      />
    </>
  );
};
